import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { RootState, useAppSelector } from "../../app";
import { setTableControlsHeight } from "../store/AnnotationTableControlsSlice";
import {
  DEFAULT_TABLE_CONTROLS_HEIGHT,
  GROUPBLOCK_TABS_HEIGHT,
  TABLE_HEADER_HEIGHT,
} from "../constants";
import useCalculateTableRowsHeightInPx from "./useCalculateTableRowsHeightInPx";

const useSetTableControlsHeight = () => {
  const dispatch = useDispatch();

  const { selectedGroupBlockId, tableControlsHeight, autoResizeDisabled } =
    useAppSelector((state: RootState) => state.annotationTableControlsReducer);

  const calculateTableRowsHeightInPx = useCalculateTableRowsHeightInPx();

  const setTableControlsHeightByLines = useCallback(
    (value?: string) => {
      if (autoResizeDisabled) {
        return;
      }

      const groupBlockId = value ?? selectedGroupBlockId;
      if (!groupBlockId) {
        return;
      }

      const tableRowsHeightInPx = calculateTableRowsHeightInPx(groupBlockId);

      if (tableRowsHeightInPx < DEFAULT_TABLE_CONTROLS_HEIGHT) {
        dispatch(
          setTableControlsHeight(
            TABLE_HEADER_HEIGHT + GROUPBLOCK_TABS_HEIGHT + tableRowsHeightInPx,
          ),
        );
      } else {
        dispatch(setTableControlsHeight(DEFAULT_TABLE_CONTROLS_HEIGHT));
      }
    },
    [
      dispatch,
      selectedGroupBlockId,
      autoResizeDisabled,
      calculateTableRowsHeightInPx,
    ],
  );

  const setTableControlsHeightOnAddLine = useCallback(() => {
    if (autoResizeDisabled) {
      return;
    }

    if (tableControlsHeight < DEFAULT_TABLE_CONTROLS_HEIGHT) {
      dispatch(setTableControlsHeight(DEFAULT_TABLE_CONTROLS_HEIGHT));
    }
  }, [tableControlsHeight, dispatch, autoResizeDisabled]);

  const setTableControlHeight = useCallback(
    (height: number) => {
      dispatch(setTableControlsHeight(height));
    },
    [dispatch],
  );

  return {
    setTableControlsHeightByLines,
    setTableControlsHeightOnAddLine,
    setTableControlHeight,
  };
};

export default useSetTableControlsHeight;
